(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery"], factory);
	else if(typeof exports === 'object')
		exports["YDJ"] = factory(require("jquery"));
	else
		root["YDJ"] = factory(root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_15__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/